import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const Title = styled.h1`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  white-space: nowrap;
  margin-bottom: 0;
`

export const SettingsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    gap: 24px;
    max-width: 1120px;
    padding: 40px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background-color: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.card};
  }
`

export const SettingsInnerContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  position: relative;
`
